import { RawProjectModel } from "../project_model.js";

class RawAdminProjectModel extends RawProjectModel {

}
const AdminProjectModel = new RawAdminProjectModel();

export { RawAdminProjectModel, AdminProjectModel }

